@if (carouselType() === AdCarouselType.SQUARE_AD || carouselType() === AdCarouselType.VERTICAL_AD) {
    @let imageStyle =
        carouselType() === AdCarouselType.SQUARE_AD
            ? "max-h-90.5 min-h-90.5 max-w-90.5 min-w-90.5 max-[360px]:max-w-[calc(100vw-32px)] max-[360px]:min-w-[calc(100vw-32px)] md:max-h-75 md:min-h-75 md:max-w-75 md:min-w-75"
            : "max-h-180.5 min-h-180.5 max-w-90.5 min-w-90.5 max-[360px]:max-w-[calc(100vw-32px)] max-[360px]:min-w-[calc(100vw-32px)] md:max-h-150 md:min-h-150 md:max-w-75 md:min-w-75";

    @let imageHeight = carouselType() === AdCarouselType.SQUARE_AD ? 300 : 600;

    <aside>
        <div class="bg-primary absolute z-1 rounded-lg">
            <span class="text-body-small p-2 text-white">{{ "carousel.ad" | transloco }}</span>
        </div>
        <div
            #emblaViewport
            [class]="imageStyle"
            class="border-neutral-variant-40/20 relative items-center justify-center overflow-hidden rounded-lg border-2"
        >
            <figure class="flex">
                @for (ad of ads(); track ad.id) {
                    <img
                        [ngSrc]="ad.image | getDirectusImage"
                        [alt]="ad.image.title"
                        [class]="imageStyle"
                        class="object-cover"
                        [width]="300"
                        [height]="imageHeight"
                        [style.cursor]="ad.url ? 'pointer' : 'default'"
                        aria-hidden="true"
                        (click)="openAd(ad)"
                    />
                }
            </figure>
        </div>
    </aside>
}

@if (carouselType() === AdCarouselType.HORIZONTAL_AD || carouselType() === AdCarouselType.TARGETED_HORIZONTAL_AD) {
    <section class="flex w-full max-w-full justify-center overflow-hidden">
        <div
            class="border-neutral-variant-40/20 relative max-h-36.5 min-h-36.5 w-full max-w-90.5 items-center justify-center overflow-hidden rounded-lg border-2 lg:max-h-100 lg:min-h-100 lg:max-w-250 lg:min-w-250"
        >
            <div class="bg-primary absolute z-1 w-fit rounded-lg">
                <span class="text-body-small p-2 text-white">{{ "carousel.ad" | transloco }}</span>
            </div>
            <div #emblaViewport class="w-full max-w-full overflow-hidden">
                <figure class="flex w-full max-w-full">
                    @for (ad of ads(); track ad.id) {
                        <img
                            [ngSrc]="ad.image | getDirectusImage"
                            [alt]="ad.image.title"
                            class="h-full max-h-36.5 w-full max-w-90.5 object-cover lg:max-h-100 lg:min-h-100 lg:max-w-250 lg:min-w-250"
                            width="1000"
                            height="400"
                            [style.cursor]="ad.url ? 'pointer' : 'default'"
                            aria-hidden="true"
                            (click)="openAd(ad)"
                        />
                    }
                </figure>
            </div>
        </div>
    </section>
}
